import React, { useEffect, useState } from "react";
import Card from "components/Card/Card";
import axios from "axios";
import apiUrl from "../../../variables/api";

import {
  Text,
  Flex,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Button,
  Textarea,
  RadioGroup,
  Stack,
  SimpleGrid,
  AbsoluteCenter,
  Center,
  useColorModeValue,
  useColorMode,
  Skeleton,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import CustomCheckbox from "../../../components/Checkbox/CustomCheckbox";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import darkStyles from "variables/darkStyles";
import Creatable from "react-select/creatable";

import locations from "variables/locations";

const initialValues = {
  dateTime: new Date(
    new Date().getTime() - new Date().getTimezoneOffset() * 60000
  )
    .toISOString()
    .slice(0, -8),
  location: "",
  accidentName: "",
  inTime: "",
  accidentDescription: "",
  accidentRavages: "",
  accidentInvestigation: "",
  accidentAddInfo: "",
};

const validate = (values) => {
  const errors = {};
  const requiredFields = Object.keys(initialValues);

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = "To pole jest obowiazkowe";
    }
  });

  return errors;
};

function Page() {
  const [peoples, setPeoples] = useState([]);
  useEffect(() => {
    axios
      .get(apiUrl + "/data/peoples", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        console.log(response.data);
        setPeoples(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [formData, setFormData] = useState(initialValues);
  const formikRef = React.useRef();
  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    console.log("Dane formularza", values);

    setFormData(values);
    axios
      .post(apiUrl + "/data/heavyAccident", values, {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        if (response.data.success) {
          formikRef.current.resetForm();
          formikRef.current.setSubmitting(false);
          return toast.success("Pomyślnie wysłano meldunek o wypadku ciężkim");
        } else {
          formikRef.current.setSubmitting(false);
          return toast.error(
            "Napotkano błąd podczas wysyłania meldunku o wypadku ciężkim"
          );
        }
      })
      .catch((error) => {
        console.error(error);
        formikRef.current.setSubmitting(false);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
  };

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Card minH="125px">
        <Formik
          initialValues={initialValues}
          validate={validate}
          onSubmit={handleSubmit}
          innerRef={formikRef}
        >
          {({ isSubmitting, formik }) => (
            <Form>
              <SimpleGrid
                columns={{ sm: 1, md: 2, xl: 4 }}
                spacing="24px"
                mb="20px"
              >
                <Field name="dateTime">
                  {({ field, form }) => (
                    <FormControl
                      id="dateTime"
                      isRequired
                      isInvalid={form.errors.dateTime && form.touched.dateTime}
                    >
                      <FormLabel>Data i godzina</FormLabel>
                      <Input
                        type="datetime-local"
                        {...field}
                        placeholder="Data i godzina"
                      />
                      <FormErrorMessage>
                        {form.errors.dateTime}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="location">
                  {({ field, form }) => (
                    <FormControl
                      id="location"
                      isRequired
                      isInvalid={form.errors.location && form.touched.location}
                    >
                      <FormLabel>Lokalizacja</FormLabel>
                      <Creatable
                        {...field}
                        options={locations}
                        placeholder="Wybierz..."
                        styles={darkStyles()}
                        value={form.values[field.name]}
                        onChange={(selectedOptions) => {
                          form.setFieldValue(field.name, selectedOptions);
                        }}
                        formatCreateLabel={(inputValue) =>
                          `Niestandardowa: ${inputValue}`
                        }
                      />
                      <FormErrorMessage>
                        {form.errors.location}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="accidentName">
                  {({ field, form }) => (
                    <FormControl
                      id="accidentName"
                      isRequired
                      isInvalid={
                        form.errors.accidentName && form.touched.accidentName
                      }
                    >
                      <FormLabel>Nastąpił wypadek</FormLabel>
                      <Input {...field} placeholder="Rodzaj wypadku" />
                      <FormErrorMessage>
                        {form.errors.accidentName}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="inTime">
                  {({ field, form }) => (
                    <FormControl
                      id="inTime"
                      isRequired
                      isInvalid={form.errors.inTime && form.touched.inTime}
                    >
                      <FormLabel>W czasie</FormLabel>
                      <Textarea
                        {...field}
                        maxH={"500px"}
                        placeholder="Rodzaj wykonywanych czynności, cel jazdy"
                      />
                      <FormErrorMessage>{form.errors.inTime}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="accidentDescription">
                  {({ field, form }) => (
                    <FormControl
                      id="accidentDescription"
                      isRequired
                      isInvalid={
                        form.errors.accidentDescription &&
                        form.touched.accidentDescription
                      }
                    >
                      <FormLabel>Szczegółowy opis wypadku</FormLabel>
                      <Textarea {...field} placeholder="Opis wypadku" maxH={"500px"} />
                      <FormErrorMessage>
                        {form.errors.accidentDescription}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="accidentRavages">
                  {({ field, form }) => (
                    <FormControl
                      id="accidentRavages"
                      isRequired
                      isInvalid={
                        form.errors.accidentRavages &&
                        form.touched.accidentRavages
                      }
                    >
                      <FormLabel>Skutki wypadku</FormLabel>
                      <Textarea {...field} placeholder="Treść"maxH={"500px"} />
                      <FormErrorMessage>
                        {form.errors.accidentRavages}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="accidentInvestigation">
                  {({ field, form }) => (
                    <FormControl
                      id="accidentInvestigation"
                      isRequired
                      isInvalid={
                        form.errors.accidentInvestigation &&
                        form.touched.accidentInvestigation
                      }
                    >
                      <FormLabel>
                        Czy i kto podjął dochodzenie powypadkowe
                      </FormLabel>
                      <Textarea {...field} placeholder="Treść" maxH={"500px"} />
                      <FormErrorMessage>
                        {form.errors.accidentInvestigation}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="accidentAddInfo">
                  {({ field, form }) => (
                    <FormControl
                      id="accidentAddInfo"
                      isRequired
                      isInvalid={
                        form.errors.accidentAddInfo &&
                        form.touched.accidentAddInfo
                      }
                    >
                      <FormLabel>Informacje dodatkowe</FormLabel>
                      <Textarea {...field} placeholder="Treść" maxH={"500px"} />
                      <FormErrorMessage>
                        {form.errors.accidentAddInfo}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
              </SimpleGrid>

              <Button
                mt={4}
                colorScheme="red"
                isLoading={isSubmitting}
                type="submit"
              >
                Wyślij
              </Button>
            </Form>
          )}
        </Formik>
      </Card>
    </Flex>
  );
}

export default Page;
